import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const CardInfo = ({
    title,
    subTitle,
    content,
    actions,
    headerActions,
    isExpanded = true,
    isOverflowVisible = false,
    isTableContent = false,
    titleClass = '',
    hasPaddingContent = true,
    hasRounded = true,
    background = 'bg-white',
}) => {
    const hasActionsBottom = actions?.length > 0

    const renderActions = allActions => {
        const hasActions = allActions && allActions?.length > 0
        return hasActions && allActions?.map(action => action)
    }

    return (
        <div
            className={clsx(
                'w-full transition-opacity duration-300 flex flex-col items-start justify-start border border-grayLines',
                isExpanded ? 'h-full' : 'h-auto',
                isTableContent ? 'overflow-hidden' : 'overflow-visible',
                hasRounded ? 'rounded-3xl' : 'rounded-none',
                background ? background : 'bg-white',
            )}
        >
            <div
                className={clsx(
                    'w-full h-auto lg:px-6 px-4 py-4 flex flex-row items-center justify-between flex-wrap border-b border-grayLines gap-y-4',
                    !hasRounded && 'bg-white',
                )}
            >
                <div
                    className={clsx(
                        'w-auto h-auto flex flex-col items-start justify-center gap-y-1',
                        titleClass,
                    )}
                >
                    <p className="font-medium text-base text-black70">
                        {title}
                    </p>
                    <p className="font-normal text-sm text-textDarkGray">
                        {subTitle}
                    </p>
                </div>
                <div className="flex md:flex-grow-0 flex-grow items-center justify-end gap-x-4">
                    {renderActions(headerActions)}
                </div>
            </div>
            <div
                className={clsx(
                    isOverflowVisible ? 'overflow-visible' : 'overflow-hidden',
                    isTableContent || !hasPaddingContent
                        ? 'p-0'
                        : ' lg:px-6 lg:py-4 px-4 py-4',
                    'w-full flex-grow h-auto flex flex-col items-center justify-start',
                )}
            >
                {content}
            </div>
            {hasActionsBottom && (
                <div className="flex w-full h-auto flex-grow items-center justify-end  rounded-bl-3xl rounded-br-3xl overflow-hidden">
                    {renderActions(actions)}
                </div>
            )}
        </div>
    )
}

CardInfo.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    content: PropTypes.node,
    actions: PropTypes.arrayOf(PropTypes.node),
    headerActions: PropTypes.arrayOf(PropTypes.node),
    isExpanded: PropTypes.bool,
    isOverflowVisible: PropTypes.bool,
    isTableContent: PropTypes.bool,
    titleClass: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    hasPaddingContent: PropTypes.bool,
    hasRounded: PropTypes.bool,
    background: PropTypes.string,
}

export default CardInfo
